
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blok-test",
      function () {
        return require("private-next-pages/blok-test.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blok-test"])
      });
    }
  